import Box from "@mui/material/Box";
import DefaultTemplate from "../templates/DefaultTemplate";
import Grid from "@mui/material/Grid";
import IconButton from "@mui/material/IconButton";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { Link } from "react-router-dom";
import { OverviewCard } from "../../components/Card/Card";
import { PDFViewerHelp } from "../HomeView";
import PageTitle from "../../components/PageTitle/PageTitle";
import Popover from "@mui/material/Popover";
import React from "react";
import Tab from "@mui/material/Tab";
import Tabs from "@mui/material/Tabs";
import TaxDocumentsList from "../../components/Profile/TaxDocumentsList";
import Typography from "@mui/material/Typography";
import { useTheme } from "@mui/material";
import {
	ContentContainerBottom,
	ContentContainerTop
} from "../../components/Container/Container";
import { HELP_MODULE_FAQ, HELP_MODULE_KEY } from "../../config/common";
import { TabPanel, tabA11yProps } from "../../components/Tabs/Tabs";

const InboxHelp = props => {

	const [anchorEl, setAnchorEl] = React.useState(null);

	const handleClick = e => {
		setAnchorEl(e.currentTarget);
	};

	const handleClose = () => {
		setAnchorEl(null);
	};

	const open = Boolean(anchorEl);
	const id = open ? "help-icon" : undefined;

	return (
		<Box>
			<IconButton
				aria-describedby={id}
				color="primary"
				onClick={handleClick}
				title="Additional Information"
			>
				<InfoOutlinedIcon fontSize="medium" />
			</IconButton>
			<Popover
				id={id}
				open={open}
				anchorEl={anchorEl}
				onClose={handleClose}
				anchorOrigin={{
					vertical: "bottom",
					horizontal: "center",
				}}
				transformOrigin={{
					vertical: "top",
					horizontal: "center",
				}}
			>
				<Box sx={{ m: 2, maxWidth: 325 }}>
					This information is provided to you for tax purposes. For information about how to use this information on your tax return, please contact:
					<Typography component="ul">
						<Typography component="li">The IRS toll free at 1-800-1040 or visit <a href="https://irs.gov" target="_blank" rel="noreferrer">IRS.gov</a></Typography>
						<Typography component="li">Your tax professional or advisor</Typography>
					</Typography>
				</Box>
			</Popover>
		</Box>
	);
};

const InboxView = ({ title, ...props }) => {

	const [tabValue, setTabValue] = React.useState(0);
	const theme = useTheme();
	const handleTabChange = (e, newTabValue) => {
		setTabValue(newTabValue);
	};

	return (
		<DefaultTemplate>
			<ContentContainerTop>
				<PageTitle title={title} />
			</ContentContainerTop>
			<ContentContainerBottom>
				<Grid container maxWidth={620} mb={8} mx="auto" /*spacing={2}*/>
					<Grid item xs={12}>
						<Tabs
							aria-label="Tax Documents Tab"
							sx={{ marginBottom: 3 }}
							onChange={handleTabChange}
							value={tabValue}
						>
							<Tab label="Tax" value={0} {...tabA11yProps(0)} sx={{ color: `${theme.palette.common.black} !important` }} />
						</Tabs>
						<TabPanel index={0} value={tabValue}>
							<OverviewCard
								content={(
									<React.Fragment>
										<TaxDocumentsList />
										<Box px={3} pt={2.5}>
											<Typography gutterBottom>
												The information displayed only includes the summed amount paid to or discharged by PHEAA. If you have other loan servicers, you must contact the servicer of those loans to find out if additional tax information will be provided. <Typography component={Link} sx={{ color: theme.palette.link.main, fontWeight: 700 }} to={`?${HELP_MODULE_KEY}=${HELP_MODULE_FAQ}&questionId=tax19`}>See our FAQ for additional information.</Typography>
											</Typography>
											<Typography>
												Only 8 years of tax history are displayed, if available.
											</Typography>
										</Box>
									</React.Fragment>
								)}
								headingAction={<InboxHelp />}
								headingText="Tax Documents"
								paddingX={0}
							/>
						</TabPanel>
					</Grid>
					<PDFViewerHelp />
				</Grid>
			</ContentContainerBottom>
		</DefaultTemplate>
	);
};

export default InboxView;